if (!customElements.get('bonus-item')) {
  customElements.define(
    'bonus-item',
    class BonusItem extends HTMLElement {
      constructor() {
          super();
          this.attachShadow({ mode: 'open' });

          // Get attributes
          const sectionId = this.getAttribute('section-id') || 'default';
          const bonusItemId = this.getAttribute('bonus-item-id') || '';
          const bonusItemDesc = this.getAttribute('bonus-item-description') || ''
          const discountable = this.getAttribute('discountable') === 'true';
          //console.log("discountable", discountable);
          //console.log("bonusItemId", bonusItemId);
          //console.log("bonusItemDesc",bonusItemDesc);
          // Determine if it should be hidden
          const isHidden = !bonusItemId || discountable;

          const match = bonusItemDesc.match(/\$(\d+)/);
          const value = match ? parseInt(match[1], 10) : 0;
      
          // Determine icon filename
          const icon = value > 0 ? `ecert-icon-item-page${value}.png` : "ecert-icon-item-pageGeneric.png";

          this.shadowRoot.innerHTML = `
              <style>
                  :host {
                      display: inline-flex;
                      align-items: center;
                  }
                  .visually-hidden {
                      display: none;
                  }
              </style>
              <span class="${isHidden ? 'visually-hidden' : ''}">
                  <span id="Bonus-Item-${sectionId}">
                      <img src="https://cdn.shopify.com/s/files/1/0709/1155/7887/files/${icon}" alt="Bonus Item">
                  </span>
              </span>
          `;
      }
  })

}
